<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">PRÉSTAMO O COMODATO POR TERCEROS (SITUACIÓN ACTUAL)</legend>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="control-label"> ¿Tiene préstamo o comodato por terceros? <b-button class="btn-popover" v-b-popover.hover.top="info.prestamos"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <legend>Datos del bien</legend>
        </div>
        <div class="row">
          <div class="col-6 form-group">
            <label class="control-label"> Tipo de bien <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_bien"><i class="far fa-question-circle"></i></b-button></label><br>
            <p-radio class="d-inline-block" name="Tipo" v-validate="'required'" v-model="form_item.tipo_bien" label="1">Inmueble </p-radio>
            <p-radio class="d-inline-block" name="Tipo" v-validate="'required'" v-model="form_item.tipo_bien" label="2">Vehiculo </p-radio>
            <br /><small class="text-danger">{{ errors.first('Tipo')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_bien =='1'">
            <label class="control-label">Tipo de inmueble <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_inmueble"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable name="inmueble" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.tipo_inmueble_id">
              <el-option v-for="option in tipos_inmuebles" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('inmueble')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_bien =='2'">
            <label class="control-label">Tipo de vehiculo <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_vehiculo"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable name="mueble" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.tipo_vehiculo_id">
              <el-option v-for="option in tipos_vehiculos" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('mueble')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_inmueble_id == 4 || form_item.tipo_vehiculo_id == 5">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique" v-validate="'required'" v-model="form_item.especifique" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique')}}</small>
          </div>
          <div class="row" v-if="form_item.tipo_bien =='2'">
            <div class="form-group col-6">
              <label class="control-label">Marca <b-button class="btn-popover" v-b-popover.hover.top="info.marca"><i class="far fa-question-circle"></i></b-button></label>
              <input class="form-control" type="text" name="marca" v-validate="'required'" v-model="form_item.marca" placeholder="Marca">
              <small class="text-danger">{{ errors.first('marca')}}</small>
            </div>
            <div class="form-group col-6">
              <label class="control-label">Model <b-button class="btn-popover" v-b-popover.hover.top="info.modelo"><i class="far fa-question-circle"></i></b-button></label>
              <input class="form-control" type="text" name="modelo" v-validate="'required'" v-model="form_item.modelo" placeholder="Modelo">
              <small class="text-danger">{{ errors.first('modelo')}}</small>
            </div>
            <div class="form-group col-6">
              <label class="control-label">Año <b-button class="btn-popover" v-b-popover.hover.top="info.anio"><i class="far fa-question-circle"></i></b-button></label>
              <input class="form-control" type="text" name="año" v-validate="'required'" v-model="form_item.anio" placeholder="Año">
              <small class="text-danger">{{ errors.first('año')}}</small>
            </div>
            <div class="form-group col-6">
              <label class="control-label">Número de Serie <b-button class="btn-popover" v-b-popover.hover.top="info.serie"><i class="far fa-question-circle"></i></b-button></label>
              <input class="form-control" type="text" name="serie" v-validate="'required'" v-model="form_item.numero_serie" placeholder="Número de Serie o Registro">
              <small class="text-danger">{{ errors.first('serie')}}</small>
            </div>
            <legend>Datos del dueño
            </legend>
            <div class="form-group col-6">
              <label class="control-label"> Dueño o titular <b-button class="btn-popover" v-b-popover.hover.top="info.titular"><i class="far fa-question-circle"></i></b-button></label><br>
              <p-radio class="d-inline-block" name="titular" v-validate="'required'" v-model="form_item.titular_tipo" label="1"> Persona Física</p-radio>
              <p-radio class="d-inline-block" name="titular" v-validate="'required'" v-model="form_item.titular_tipo" label="2"> Persona Moral</p-radio>
              <small class="text-danger">{{ errors.first('titular')}}</small>
            </div>
            <div class="form-group col-6">
              <label class="control-label">Nombre del Dueño o Titular <b-button class="btn-popover" v-b-popover.hover.top="info.nombre"><i class="far fa-question-circle"></i></b-button></label>
              <input class="form-control" type="text" name="nombre" v-validate="'required'" v-model="form_item.nombre_titular" placeholder="Nombre del Dueño o Titular">
              <small class="text-danger">{{ errors.first('nombre')}}</small>
            </div>
            <div class="form-group col-6">
              <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc"><i class="far fa-question-circle"></i></b-button></label>
              <input class="form-control" type="text" name="rfc" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc" placeholder="RFC">
              <small class="text-danger">{{ errors.first('rfc')}}</small>
            </div>
            <div class="form-group col-6">
              <label class="control-label">Relación con el dueño o titular <b-button class="btn-popover" v-b-popover.hover.top="info.relacion"><i class="far fa-question-circle"></i></b-button></label>
              <input class="form-control" type="text" name="relacion" v-validate="'required'" v-model="form_item.relacion_titular" placeholder="Relación con el dueño o titular">
              <small class="text-danger">{{ errors.first('relacion')}}</small>
            </div>
            <legend>Donde se encuentra registrado <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
            </legend>
            <div class="form-group  col-6">
              <label class="control-label"> País </label>
              <el-select  clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.pais_id">
                <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
                </el-option>
              </el-select>
              <small class="text-danger">{{ errors.first('pais') }}</small>
            </div>
            <div class="form-group col-6" v-if="form_item.pais_id==150">
              <label class="control-label"> Entidad Federativa </label>
              <el-select  clearable class="select-default" name="entidad" v-validate="'required'" filterable placeholder="Entidad" v-model="form_item.entidad_federativa_id">
                <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent">
                </el-option>
              </el-select>
              <small class="text-danger">{{ errors.first('entidad') }}</small>
            </div>
          </div>
          <domicilio v-model="n_domicilio" :vista="false" titulo="/ Ubicación del Inmueble" v-if="form_item.tipo_bien =='1'">
          </domicilio>
          <div class="form-group col-md-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.aclaraciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="!edit_item ">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.tipo_bien="{ item }">
                <div>{{filterTipoBien(item.tipo_bien)}}</div>
              </template>
              <template v-slot:item.tipo_inmueble_id="{ item }">
                <div>
                  {{item.tipo_inmueble_id?filterInmueble(item.tipo_inmueble_id):''}}{{item.tipo_vehiculo_id?filterMueble(item.tipo_vehiculo_id):''}}
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        ip_id: 1,
        add_item: false,
        edit_item: false,
        bandera: "0",
        search: '',
        form_item: {},
        table_list: [],
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Inmueble / Vehiculo',
          value: 'tipo_bien',
          align: 'center',
        }, {
          text: 'Tipo de bien',
          value: 'tipo_inmueble_id',
          align: 'center',
        }],
        info: {
          prestamos: 'Para la declaración de inicio reportar la situación de préstamo o comodato por terceros a la fecha de ingreso al empleo, cargo o comisión. ' + 'Para la declaración de modificación reportar la situación de préstamo o comodato por terceros del año inmediato anterior. ' + 'Para la declaración de conclusión reportar la situación de préstamo o comodato por terceros a la fecha de conclusión del empleo, cargo o comisión. ' + 'En este apartado se deberá indicar si existe algún bien (inmueble, vehículo) prestado por un tercero y que el Declarante use.',
          tipo_bien: 'Indicar el bien que le haya sido prestado.',
          tipo_inmueble: 'Elegir alguna de las siguientes opciones: casa, departamento, edificio, local comercial, bodega, palco, rancho, terreno, otro (especifique).',
          tipo_vehiculo: 'Seleccionar el tipo de vehículo del listado desplegable: automóvil/motocicleta, aeronave, barco/yate, otro, especifique.',
          marca: 'Elegir la marca del catálogo desplegable.',
          modelo: 'Señalar el modelo del vehículo, de acuerdo a la marca. (Ejemplo marca Volkswagen, modelo Jetta).',
          anio: 'Indicar el año del vehículo.',
          serie: 'Proporcionar el número de serie o registro que aparece en la factura y/o en su caso, tarjeta de circulación.',
          titular: 'Seleccionar si es persona física o persona moral.',
          nombre: 'Deberá proporcionar el nombre completo y/o razón social del propietario del bien prestado y usado por el Declarante.',
          rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
          relacion: 'Indicar que tipo de relación existe en entre el dueño del bien prestado y el Declarante.',
          lugar: 'Indicar si se encuentra registrado en México o en el extranjero. Señalando la entidad federativa o país según corresponda.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
        /*             */
        n_domicilio: {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        },
      };
    },
    watch: {
      n_domicilio: {
        handler: function (val, oldVal) {
          if (this.n_domicilio) {
            this.form_item.pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
            this.form_item.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.form_item.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.form_item.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.form_item.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.form_item.vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.form_item.numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.form_item.numint = this.n_domicilio.int ? this.n_domicilio.int : "";
            this.form_item.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          }
        },
        immediate: true,
        deep: true
      },
    },
    methods: {
      editDomicilio() {
        if (this.form_item) {
          this.n_domicilio.pais_id = this.form_item.pais ? this.form_item.pais : 150;
          this.n_domicilio.entidadF = this.form_item.entidad_federativa_id ? this.form_item.entidad_federativa_id : "";
          this.n_domicilio.municipio = this.form_item.municipio_id ? this.form_item.municipio_id : "";
          this.n_domicilio.localidad = this.form_item.localidad_id ? this.form_item.localidad_id : "";
          this.n_domicilio.cp = this.form_item.cp ? this.form_item.cp : "";
          this.n_domicilio.vialidad_nombre = this.form_item.vialidad_nombre ? this.form_item.vialidad_nombre : "";
          this.n_domicilio.vialidad = this.form_item.vialidad_tipo ? this.form_item.vialidad_tipo : "";
          this.n_domicilio.ext = this.form_item.numext ? this.form_item.numext : "";
          this.n_domicilio.int = this.form_item.numint ? this.form_item.numint : "";
          this.n_domicilio.colonia = this.form_item.colonia ? this.form_item.colonia : "";
        }
      },
      initDomicilio() {
        this.n_domicilio = {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        };
      },
      showItem() {
        this.add_item = true;
        if (!this.form_item.pais_id) {
          //El id Mexico es 150
          this.form_item.pais_id = 150;
        }
        this.$validator.resume();
      },
      cancelEdit() {
        this.add_item = false;
        this.form_item = {};
        this.initDomicilio();
        this.edit_item = false;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.checkDomicilio();
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("prcomodato", this.form_item).then(response => {
                this.StepOk("Guardado");
                //if (this.edit_item === undefined || this.edit_item === null) {
                if (!this.edit_item) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
            this.scrolling();
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = true;
        this.form_item = {
          ...item
        };
        this.editDomicilio();
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("prcomodato/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
      checkDomicilio() {
        if (this.form_item.tipo_bien == '1') {
          this.form_item.tipo_vehiculo_id = null;
          this.form_item.marca = null;
          this.form_item.modelo = null;
          this.form_item.anio = null;
          this.form_item.numero_serie = null;
          this.form_item.titular_tipo = null;
          this.form_item.nombre_titular = null;
          this.form_item.rfc = null;
          this.form_item.relacion_titular = null;

          if (this.n_domicilio) {
            this.form_item.pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
            this.form_item.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.form_item.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.form_item.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.form_item.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.form_item.vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.form_item.numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.form_item.numint = this.n_domicilio.int ? this.n_domicilio.int : "";
            this.form_item.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          }
        } else {
          this.form_item.tipo_inmueble_id = null;
          this.form_item.municipio_id = null;
          this.form_item.localidad_id = null;
          this.form_item.cp = null;
          this.form_item.numext = null;
          this.form_item.numint = null;
          this.form_item.colonia = null;
          this.form_item.vialidad_nombre = null;
        }
      },
    },
    created() {
      this.ip_id = this.getKey('uid');
      //this.getLocalidades(97250);
      this.$http.get("prcomodato").then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      });
    },
    mounted() {
      this.checkCatalogs();
      this.form_item.pais_id = 150;
    },
  };

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Pasivos/PrestamoComodato.vue